import { z } from "zod"

import { FreightTerms, Incoterms } from "@/graphql/codegen/graphql"

export const CostPackageSchema = z.object({
  warehouses: z
    .array(z.object({ shipToWarehouseAreaId: z.string().min(1, "Warehouse is required") }))
    .min(1, "Warehouse is required"),
  freightTerms: z
    .union([z.nativeEnum(FreightTerms), z.literal("")])
    .refine((value) => value !== "", { message: "Freight is required" }),
  incoterms: z
    .union([z.nativeEnum(Incoterms), z.literal("")])
    .refine((value) => value !== "", { message: "Incoterms is required" }),
  incotermsLocationId: z.string().min(1, "Incoterms Location is required"),
})

export type CostPackageSchemaFormValues = z.input<typeof CostPackageSchema>

export const COST_PACKAGE_DEFAULT_FORM_VALUES: CostPackageSchemaFormValues = {
  warehouses: [{ shipToWarehouseAreaId: "" }],
  freightTerms: "",
  incoterms: "",
  incotermsLocationId: "",
}
